import { Tag } from 'antd';
import styles from './client-insurance-status.module.scss';
import { CLIENT_INSURANCE_STATUS_MAP } from './constants';
import type { IClientInsuranceStatusProps } from './types';

export const ClientInsuranceStatus = (props: IClientInsuranceStatusProps) => {
  const { status } = props;

  const statusConfig = CLIENT_INSURANCE_STATUS_MAP[status || 'no_insurance'];
  const { backgroundColor, icon: Icon, text, textColor } = statusConfig;

  return (
    <Tag className={styles.status} icon={<Icon />} style={{ backgroundColor, color: textColor }}>
      {text}
    </Tag>
  );
};
